// initial state
const state = () => ({
  isNavOpen: false,
  isDark: false
});

// getters
const getters = {};

// actions
const actions = {};

// mutations
const mutations = {
  TOGGLE_NAV(state, bool) {
    state.isNavOpen = bool;
  },
  TOGGLE_DARK(state, bool) {
    state.isDark = bool;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
